import { useGlobalStore } from "../Stores/Store";
import { MobileTabItem } from "../Components/MobileTabItem";
import { SearchInput } from "../Components/SearchInput";
import { useEffect, useRef } from "react";

export function MobileHeader() {
    const { categories, filter, setTab: setTabRef, setFilter, currentTab } = useGlobalStore();
    const listRef = useRef<HTMLUListElement>(null);

    const handleSnapChange = (event) => {
        const target = event.snapTargetInline as HTMLLIElement;

        setTab(target.dataset.slug, false);
    };

    const setTab = (tab: string, shouldScroll: boolean = true) => {
        if (shouldScroll) {
            const element = document.querySelector(`[data-slug=${tab}]`);

            element?.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest",
            });
        }
        
        setTabRef(tab);
    };

    const handleSnapChanging = (event) => {
        const target = event.snapTargetInline as HTMLLIElement;

        document.querySelector('.meuselfstorage__calculadora__mobile-header__categories__category--active')?.classList.toggle('meuselfstorage__calculadora__mobile-header__categories__category--active');
        target.classList.toggle('meuselfstorage__calculadora__mobile-header__categories__category--active');
    };

    useEffect(() => {
        if (categories.length) {
            listRef.current?.scrollTo(0, 0);
        }

        if (listRef.current) {
            listRef.current.addEventListener("scrollsnapchanging", handleSnapChanging);
            listRef.current.addEventListener("scrollsnapchange", handleSnapChange);
        }

        return () => {
            listRef.current?.removeEventListener("scrollsnapchange", handleSnapChange);
            listRef.current?.removeEventListener("scrollsnapchanging", handleSnapChanging);
        };
    }, [categories]);

    useEffect(() => {
        if (categories.length && filter === "") {
            setTimeout(() => {
                document.querySelector('.meuselfstorage__calculadora__mobile-header__categories__category--active').classList.remove('meuselfstorage__calculadora__mobile-header__categories__category--active');
                document.querySelector('.meuselfstorage__calculadora__mobile-header__categories li').classList.add('meuselfstorage__calculadora__mobile-header__categories__category--active');
            });
        }

        if (categories.length) {
            listRef.current?.scrollTo(0, 0);
        }
    }, [categories, filter]);

    useEffect(() => {
        document.querySelector('.meuselfstorage__tab__content__item')?.scrollIntoView({
            block: "nearest",
            behavior: "smooth",
            inline: "center",
        });
    }, [currentTab]);

    return (
        <>
            <h2 className="calculadora__mobile-heading">Indique seus objetos para calcular o tamanho do box:</h2>
            <div className="meuselfstorage__calculadora__mobile-header">
                <div className="meuselfstorage__calculadora__mobile-header__wrapper">
                    <div className="meuselfstorage__calculadora__mobile-header__categories">
                        <ul ref={listRef}>
                            {categories.map((category) => (
                                <MobileTabItem key={category.id} slug={category.slug} setTab={setTab} currentTab={currentTab}>
                                    {category.name}
                                </MobileTabItem>
                            ))}

                            <MobileTabItem
                                slug="suas_medidas"
                                currentTab={currentTab}
                                setTab={setTab}
                            >Suas medidas</MobileTabItem>
                        </ul>
                    </div>
                    <SearchInput setFilter={setFilter} defaultValue={filter} />
                </div>
            </div>
        </>
    );
}
